import { css } from 'styled-components';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { pxToRem } from '../../../foundation/spacing/utils.js';

var widthOfShadowBlock = '1rem';
var clipAmount = 20;
var stickyStyles = css(["z-index:1;background-color:", ";position:sticky;", ";", ";&[data-sticky-column='left']{border-right:none;box-shadow:-", " 0 0 #fff;}&[data-sticky-column='left']::before{display:block;position:absolute;content:' ';width:", ";height:100%;top:0;right:0;box-shadow:", ";clip-path:inset( -", " -", " -", " ", " );}&[data-sticky-column='right']{border-left:none;box-shadow:", " 0 0 #fff;}&[data-sticky-column='right']::before{display:block;position:absolute;content:' ';width:", ";height:100%;top:0;left:0;box-shadow:", ";clip-path:inset(-", " 100% -", " -", ");}"], themeGet('colors.background.50'), function (_ref) {
  var $stickyColumn = _ref.$stickyColumn;
  return $stickyColumn === 'left' && css(["left:0;"]);
}, function (_ref2) {
  var $stickyColumn = _ref2.$stickyColumn;
  return $stickyColumn === 'right' && css(["right:0;"]);
}, pxToRem(10), widthOfShadowBlock, themeGet('dropShadow.300'), pxToRem(clipAmount), pxToRem(clipAmount), pxToRem(clipAmount), widthOfShadowBlock, pxToRem(10), widthOfShadowBlock, themeGet('dropShadow.300'), pxToRem(clipAmount), pxToRem(clipAmount), widthOfShadowBlock);
var hiddenStyles = css(["display:none;"]);
var tableCellStyles = css(["margin:0;vertical-align:middle;text-align:left;min-width:min-content;", ";", ";"], function (_ref3) {
  var $hide = _ref3.$hide;
  return $hide && hiddenStyles;
}, function (_ref4) {
  var $stickyColumn = _ref4.$stickyColumn;
  return $stickyColumn !== undefined && stickyStyles;
});

export { tableCellStyles };
